"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderLineStatus = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineById_1 = require("./getOrderLineById");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const updateOrderLineStatus = async (supabase, order_line_id, status) => {
    const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
    if (!order_line.versions)
        throw new Error("No versions found");
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        throw new Error("No latest version found");
    try {
        latest_version.status = status;
        await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, latest_version);
    }
    catch (e) {
        console.log("Error updating order line status", e);
    }
};
exports.updateOrderLineStatus = updateOrderLineStatus;
